module.exports = __webpack_public_path__ + "static/media/EquityAnalytics.e3e4a88f.mp4";